import { ApiError } from "@ic-anywhere/ic-dal";
import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { useAtom } from "jotai";
import { createInvitationRequest, deleteInvitationRequest } from "src/api/invitationRequests/invitationRequest.api";
import useCrmRepository from "src/api/useCrmRepository";
import { userProfileStateAtom } from "src/state/userProfileAtoms";

export const useCreateInvitationRequestMutation = (
  eventId: string,
  onSuccess: () => void,
  onError: (message: string) => void
): UseMutationResult<void, ApiError, void> => {
  const repo = useCrmRepository();
  const [userState] = useAtom(userProfileStateAtom);
  const client = useQueryClient();

  return useMutation({
    mutationFn: () => createInvitationRequest(repo, eventId),
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: ["useGetInvitationRequest", eventId, userState.userInfo.userId],
      });
      onSuccess();
    },
    onError: (err: ApiError) => {
      const message = err.message ?? "Unexpected error ...";
      onError(message);
    },
  });
};

export const useDeleteInvitationRequestMutation = (
  eventId: string,
  invitationRequestId: string,
  onSuccess: () => void,
  onError: (message: string) => void
): UseMutationResult<void, ApiError, void> => {
  const repo = useCrmRepository();
  const [userState] = useAtom(userProfileStateAtom);
  const client = useQueryClient();

  return useMutation({
    mutationFn: () => deleteInvitationRequest(repo, eventId, invitationRequestId),
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: ["useGetInvitationRequest", eventId, userState.userInfo.userId],
      });
      onSuccess();
    },
    onError: (err: ApiError) => {
      const message = err?.message ?? "Unexpected error ...";

      onError(message);
    },
  });
};
